module.exports = __webpack_public_path__ + "img/goview.ec31e268.png";